<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroAconexFindFast" />
    <!--Section :content="powerfulTagSearch" />
    <Section :content="linkedDrawingsSpecs" /-->
    <Section :content="contextualTextSearch" />
    <Section :content="tagSearch" />
    <Section :content="conceptualSearch" />
    <Section :content="advancedSearch" />
    <Section :content="resultsHierarchy" />
    <Section :content="pageHyperlinks" />
    <Section :content="systemHyperlinks" />
    <Section :content="openFast" />
    <call-to-action-aconex-register />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
import CallToActionAconexRegister from '../components/call-to-action-aconex-register.vue';
export default {
  name: 'AconexFindFast',
  components: {
    MainNavBar,
    Hero,
    Section,
    CallToAction,
    GmxFooter,
    CallToActionAconexRegister
  },
  data() {
    return { 
      heroAconexFindFast: { 
        eyebrowIcon: '',
        eyebrowTitle: '',
        eyebrowSubtitle: '',
        header: 'Find Information in Minutes, Not Hours',
        subheader: 'After automatic registration of documents using the Accelerator, Aconex project members can find actionable information in seconds using the Accelerator\'s powerful search, tag and document linking capabilities.',
        img: '',
        videoId: '961761656',
        buttons: [
          /*{ label: 'Text Search', path: '', id: '' },
          { label: 'Tag Search', path: '', id: '' },
          { label: 'Tag Links', path: '', id: '' },*/
          { label: 'Text Search', path: '', id: 'contextual-text-search' },
          { label: 'Tag Search', path: '', id: 'tag-search' },
          { label: 'Conceptual Search', path: '', id: 'conceptual-search' },
          { label: 'Advanced Search', path: '', id: 'advanced-search' },
          { label: 'Results Hierarchy', path: '', id: 'results-hierarchy' },
          { label: 'Page Hyperlinks', path: '', id: 'page-hyperlinks' },
          { label: 'System Hyperlinks', path: '', id: 'system-hyperlinks' },
          { label: 'Open Results Fast', path: '', id: 'open-fast' },
        ]
      },
      contextualTextSearch: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Contextual Text Search',
        paragraphs: [
          'To find actionable information fast, enter any search words and refine them as needed. That\'s it, as simple as it gets.',
          'Text searches return highly relevant results within Unit of Thought contexts, where a Unit of Thought is any paragraph, title, note, etc., as opposed to an entire page search.',
        ],
        id: 'contextual-text-search',
        image: 'contextual-text-search.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      tagSearch: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Tag Search',
        paragraphs: [
          'The Aconex Accelerator allows you to search for all the document and system tags in your project.',
          'Searching a document tag returns all of the Units of Thought that contain that tag in any PDF. ',
          'A system tag search returns the system itself as well as all objects linked to that system, such as images, documents, files, and Units of Thought.',
        ],
        id: 'tag-search',
        image: 'tag-search.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      conceptualSearch: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Conceptual Search',
        paragraphs: [
          'With conceptual search you do not search using direct text, but for concepts, such as searching for all documents, persons, rooms, beams, or all substructures.',
          'The conceptual search understands conceptual hierarchies. For example, searching for files will return all file types (documents, videos, images, etc), and you can also narrow the file-type search to return only images.',
          'Basic conceptual information is automatically available when using the Aconex Accelerator. By adding a Systems Digital Twin, project specific conceptual searches becomes available.',
        ],
        id: 'conceptual-search',
        image: 'conceptual-search.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      advancedSearch: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Advanced Search',
        paragraphs: [
          'To further refine your search results, you can use the logical operators "and", "or", and "not", along with the wildcards * and #',
          'All available search techniques can be combined to find exactly what you\'re looking for.',
        ],
        id: 'advanced-search',
        image: 'advanced-search.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      resultsHierarchy: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Results Hierarchy',
        paragraphs: [
          'To quickly find actionable information and understand its context, you can view Units of Thought and open documents, tags, and system objects directly from the search results. The Accelerator search pane remains open for you to further refine your search query as needed.',
          'All search results are displayed within its hierarchy. You can navigate to and open any parent object in the hierarchy simply by clicking on them.',
        ],
        id: 'results-hierarchy',
        image: 'results-hierarchy.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      pageHyperlinks: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Page Hyperlinks',
        paragraphs: [
          'The Aconex Accelerator writes page tag hyperlinks directly into your PDFs stored in the TrinPod\u2122, while the original PDF without hyperlinks is uploaded to Aconex.',
          'To navigate directly to the referenced sheet or page, simply click the hyperlink.',
        ],
        id: 'page-hyperlinks',
        image: 'page-hyperlinks.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      systemHyperlinks: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'System Hyperlinks',
        paragraphs: [
          'The Aconex Accelerator writes system tag hyperlinks directly into your PDFs stored in the TrinPod\u2122, while the original PDFs without hyperlinks is uploaded to Aconex.',
          'Simply clicking on a system tag hyperlink triggers the relevant tag search, which finds all objects linked to that system, such as images, documents, files, and Units of Thought.'
        ],
        id: 'system-hyperlinks',
        image: 'system-hyperlinks.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      openFast: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Open Results Fast',
        paragraphs: [
          'Using the Accelerator search, it is not always needed to open any documents at all. The results display contextual information, fast.',
          'Instead of slowly opening a whole document of many pages as competing systems do, the Accelerator opens only the single page referenced in the search results, fast.',
          'On registration, the Accelerator splits all your PDF sets into pages and then further into Units of Thought on those pages for contextual search and adds navigation bar links to the bottom of the single PDF pages to enable set navigation.',
        ],
        id: 'open-fast',
        image: 'cors.jpg',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      aconexRegisterCTA: {
        header: 'Try It Now',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
